<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="VALORES ADICIONALES POR PUESTO" key="1">
          <g-master name="valadicxpuesto"
                    :endpoint="valadicMaster.endpoint"
                    :tableSetup="valadicMaster.tableSetup"
                    :modalFieldsSetup="valadicMaster.modalFieldsSetup"
                    modalWidth="90%"
                    @action="masterAction"
                    ref="valadicXPuestoMaster"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-lookup endpoint="hierarchy_lookup"
                            label="Puesto"
                            :decorator="['puesto', {rules: [{required: true, message: 'Valor requerido'}]}]"
                            :formItemConfig="fiOptions"
                            :params="id_h_att2">
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown label="Cargo"
                              :formItemConfig="fiOptions"
                              endpoint="jobs"
                              :decorator="['cargo', { rules: [{ required: false , message: 'Valor requerido' }] }]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup endpoint="coc"
                            label="Concepto: "
                            :formItemConfig="fiOptions"
                            :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Valor">
                    <a-input-number style="width: 100%"
                                    v-decorator="['valor', { rules: [{ required: false}] }]"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Retroactivo"
                              :formItemConfig="fiOptions" :params="estadoSN"
                              :decorator="['retro', { rules: [{ required: false }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha Inicial')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD"
                                   v-decorator="['init_date', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha Reporte Aumento')">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD"
                                   v-decorator="['date_rep', { rules: [{ required: false }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptionsRadio">
                  <a-form-item v-bind="fiOptions" :label="$t('Seleccione una opción')">
                    <a-radio-group v-decorator="['columna_seleccionada']">
                      <a-radio value="prop_dias_lab">
                        pr_dias
                      </a-radio>
                      <a-radio value="por_turno_lab">
                        x_turno
                      </a-radio>
                      <a-radio value="val_fijo_per">
                        val_fijo
                      </a-radio>
                      <a-radio value="val_fijo_2q">
                        val_fijo_2q
                      </a-radio>
                      <a-radio value="prop_dias_lab_2q">
                        pr_dias_2q
                      </a-radio>
                      <a-radio value="por_turno_lab_2q">
                        x_turno_2q
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-modal
      title="Crear / Editar"
      :visible="visible"
      width="50%"
      :confirm-loading="confirmLoading"
      @ok="guardarValadicXPuesto"
      @cancel="handleCancel"
    >
      <a-row :gutter="[16,16]">
        <a-form-model layout="vertical" :model="iValadicXPuesto" :rules="formRules"
                      @submit.native.prevent ref="valadicXPuesto">
          <a-col v-bind="colSpan">
            <a-form-model-item label="Valor" prop="valor" has-feedback>
              <a-input-number style="width: 100%;" v-model="iValadicXPuesto.valor"></a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpan">
            <a-form-item :label="$t('Retroactivo')" prop="retro">
              <form-model-dropdown style="width: 100%"
                                   endpoint="hierarchy_lookup"
                                   v-model="iValadicXPuesto.retro"
                                   :params="estadoSN"
              >
              </form-model-dropdown>
            </a-form-item>
          </a-col>
          <a-col v-bind="colSpan">
            <a-form-model-item :label="$t('Fecha Inicial')" prop="init_date" >
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD"
                             v-model="iValadicXPuesto.init_date"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpan">
            <a-form-model-item :label="$t('Fecha Reporte Aumento')" prop="date_rep" >
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD"
                             v-model="iValadicXPuesto.date_rep"/>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colOptionsRadio">
            <a-form-item :label="$t('Seleccione una opción')">
              <a-radio-group v-model="columna_seleccionada">
                <a-radio value="prop_dias_lab">
                  pr_dias
                </a-radio>
                <a-radio value="por_turno_lab">
                  x_turno
                </a-radio>
                <a-radio value="val_fijo_per">
                  val_fijo
                </a-radio>
                <a-radio value="val_fijo_2q">
                  val_fijo_2q
                </a-radio>
                <a-radio value="prop_dias_lab_2q">
                  pr_dias_2q
                </a-radio>
                <a-radio value="por_turno_lab_2q">
                  x_turno_2q
                </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-form-model>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil('valadic_puesto')
    },
    data () {
      return {
        estadoSN: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        columna_seleccionada: {},
        formRules: {},
        iValadicXPuesto: {},
        visible: false,
        confirmLoading: false,
        por_turno_lab: false,
        por_turno_lab_2q: false,
        prop_dias_lab: false,
        prop_dias_lab_2q: false,
        val_fijo_2q: false,
        val_fijo_per: false,
        por_turno_lab_new: false,
        por_turno_lab_2q_new: false,
        prop_dias_lab_new: false,
        prop_dias_lab_2q_new: false,
        val_fijo_2q_new: false,
        val_fijo_per_new: false,
        id_h_att2: {
          h_lookup_type: 'ID_H_ATT2',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        colOptionsRadio: {xs: 24, sm: 24},
        colSpan: {
          xs: 24,
          md: 8,
          sm: 12
        },
        fiOptions: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21},
          'has-feedback': true
        },
        valadicMaster: {
          endpoint: 'valadic_puesto',
          tableSetup: {
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 5,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40', '100', '200'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            actions: {
              actions: [
                {
                  name: 'customEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'customDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            columns: [
              {title: 'Puesto', dataIndex: 'puesto_desc', sorter: true},
              {title: 'Cargo', dataIndex: 'job_name', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Valor', dataIndex: 'valor', sorter: true},
              {title: 'pr_dias', dataIndex: 'prop_dias_lab', sorter: true},
              {title: 'x_turno', dataIndex: 'por_turno_lab', sorter: true},
              {title: 'val_fijo', dataIndex: 'val_fijo_per', sorter: true},
              {title: 'val_fijo_2q', dataIndex: 'val_fijo_2q', sorter: true},
              {title: 'pr_dias_2q', dataIndex: 'prop_dias_lab_2q', sorter: true},
              {title: 'x_turno_2q', dataIndex: 'por_turno_lab_2q', sorter: true},
              {title: 'Retroactivo', dataIndex: 'retro_desc', sorter: true},
              {title: 'Fecha Inicial', dataIndex: 'init_date_format', sorter: true},
              {title: 'Fecha Reporte Aumento', dataIndex: 'date_rep_format', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'cargo'},
            {name: 'id_coc'},
            {name: 'por_turno_lab'},
            {name: 'por_turno_lab_2q'},
            {name: 'prop_dias_lab'},
            {name: 'prop_dias_lab_2q'},
            {name: 'puesto'},
            {name: 'val_fijo_2q'},
            {name: 'val_fijo_per'},
            {name: 'valor'},
            {name: 'retro'},
            {name: 'init_date'},
            {name: 'date_rep'}
          ]
        },
        paramsT: {},
        endpointExcel: 'valadic_puesto_/downloadExcel',
        fileNameExcel: 'AdicionalesPorPuesto'
      }
    },
    methods: {
      initFormRules () {
        this.formRules = {
          name: [{required: true, message: 'Valor requerido'}]
        }
      },
      guardarValadicXPuesto (e) {
        this.confirmLoading = true
        return new Promise((resolve, reject) => {
          this.httpClient.getInstance().put('valadic_puesto/rnd', {
            ...this.iValadicXPuesto,
            'columna_seleccionada': this.columna_seleccionada
          })
            .then(() => {
              this.$refs.valadicXPuestoMaster.$refs.datatable.loadData()
              resolve()
            })
            .catch((error) => {
              Mensajes.error('Error', 'No fue posible actualizar el registro')
              reject(error)
            }).then(() => {
              this.visible = false
              this.confirmLoading = false
            })
        })
      },
      handleCancel (e) {
        this.visible = false
      },
      masterAction (action) {
        switch (action.action) {
          case 'customEdit':
            this.iValadicXPuesto = {...action.record}
            if (this.iValadicXPuesto.prop_dias_lab === 'X') {
              this.columna_seleccionada = 'prop_dias_lab'
            } else if (this.iValadicXPuesto.por_turno_lab === 'X') {
              this.columna_seleccionada = 'por_turno_lab'
            } else if (this.iValadicXPuesto.val_fijo_per === 'X') {
              this.columna_seleccionada = 'val_fijo_per'
            } else if (this.iValadicXPuesto.val_fijo_2q === 'X') {
              this.columna_seleccionada = 'val_fijo_2q'
            } else if (this.iValadicXPuesto.prop_dias_lab_2q === 'X') {
              this.columna_seleccionada = 'prop_dias_lab_2q'
            } else if (this.iValadicXPuesto.por_turno_lab_2q === 'X') {
              this.columna_seleccionada = 'por_turno_lab_2q'
            }
            this.visible = true
            break
          case 'customDelete':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('valadic_puesto/rnd', {
                    data: action.record
                  })
                    .then(() => {
                      this.$refs.valadicXPuestoMaster.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () {
              }
            })
            break
        }
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.valadicMaster.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Valadic/ValadicXPuesto.vue